import Banner from "./Banner";
import type { BannerProps } from "./shared";

export default function HeaderBanner({ testId = "header-banner", ...props }: Omit<BannerProps, "layout">) {
  return <Banner {...props} layout="header" testId={testId} />;
}
